import React from 'react'
import MaterialSymbol from '../material-symbol'

const Help = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="help" {...props} />
))

Help.displayName = 'Help'

export default Help
